import { FC, useEffect } from "react";

import { AnalyticsEvent } from "@repo/edtech-analytics";
import { getUploadUrl } from "@repo/edtech-api";
import { ArrowDownAndBracketTrailingIcon, FlipChartIcon } from "@repo/edtech-assets";
import { SnackBarType } from "@repo/edtech-ui-kit";
import clsx from "clsx";

import {
  ExtendedLesson,
  TrackFn,
  useSnackbar,
} from '../../../../model';

import st from "./Presentation.module.scss";

type Props = {
  lesson: ExtendedLesson,
  onFinishLesson: TrackFn,
  className?: string,
};

export const Presentation: FC<Props> = ({
  lesson,
  onFinishLesson,
  className,
}) => {
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    onFinishLesson(
      { type: AnalyticsEvent.Completed }, true, true,
    );
  }, [ onFinishLesson ]);

  const handleClick = (file: string) => {
    if (!file) {
      showSnackbar(
        `Не удалось загрузить урок ${lesson.title}`, SnackBarType.Error, "Попробуйте еще раз",
      );
    }
    onFinishLesson({ type: AnalyticsEvent.Downloaded });
  };

  return (
    <div className={clsx(st.presentation, className)}>
      {
        lesson.preview && (
          <img
            alt=""
            className={st.preview}
            src={getUploadUrl(lesson.preview)}
          />
        )
      }
      <div className={st.content}>
        <FlipChartIcon className={st.icon} />
        <h2 className={st.title}>
          Эта презентация недоступна для просмотра в приложении
        </h2>
        <p className={st.description}>
          Вы можете скачать её и открыть на своём устройстве
        </p>
        <a
          download
          className={st.link}
          href={lesson.file ? getUploadUrl(lesson.file) : undefined}
          onClick={() => handleClick(lesson.file)}
        >
          <ArrowDownAndBracketTrailingIcon />
          {' '}
          Скачать
        </a>
      </div>
    </div>
  );
};
